<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { useCoachInteractionStore } from '@/js/stores/coach-interaction';
    import { watch } from 'vue';
    import { ICoachingForm } from '@/js/services/api/coachingForm/types';
    import { IProtocol } from '@/js/services/api/protocol/protocolModel';

    import CoachingForm from './CoachingForm.vue';

    const props = defineProps<{
        form: ICoachingForm;
        protocol?: IProtocol;
        preview?: boolean;
    }>();

    const coachInteractionStore = useCoachInteractionStore();

    watch(
        () => props.form,
        () => {
            if (props.protocol) {
                coachInteractionStore.setProtocol(props.form, props.protocol);
            } else {
                coachInteractionStore.initProtocol(props.form);
            }
        },
        { deep: true, immediate: true }
    );
</script>
<template>
    <CoachingForm
        v-model:protocol-form-state="coachInteractionStore.protocol"
        :preview="props.preview"
        :point-map="coachInteractionStore.sectionPoints"
    />
</template>
